import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { SessionStorageService } from '../../storage/session-storage.service';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss'],
})
export class MaintenanceComponent implements OnInit {

  contentDesc: string = '';

  constructor(
    private location: Location,
    private sessionStorageService: SessionStorageService
  ) { }

  ngOnInit(): void {
    let maintenanceMsg = this.sessionStorageService.getItem('maintenanceMsg') ?? null;
    this.contentDesc = maintenanceMsg ?? 'system.maintenance.400';
  }

  reload() {
    if (window.navigator.onLine) {
      this.location.back();
    }
  }

}
